import axios, { AxiosHeaders } from 'axios';
import LoginForm from '@/components/LoginForm'
import { getServerEnv } from '.';
import { Modal, message } from 'antd';

const DEFAULT_ERROR_CODE = 10000;

const request = axios.create({
  baseURL: '/',
});

export class BizError extends Error {
  code: number;
  constructor(message: string, code: number = DEFAULT_ERROR_CODE) {
    super(message);
    this.name = 'BizError';
    this.code = code;
  }
}

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()!.split(';').shift();
  }

  return;
}

const CSRF_KEY = 'x-csrf-token';
request.interceptors.request.use((config) => {
  const token = getCookie(CSRF_KEY);

  const headers = new AxiosHeaders({ ...config.headers, [CSRF_KEY]: token! });

  config.headers = headers;

  return config;
});

let modalRef;

export async function login(params: { username: string, password: string }): Promise<any> {
  const { username, password } = params;

  return request('/login/doLoginByPwd', { method: 'POST', data: {
    username,
    password: btoa(password),
  } });
}

// 添加响应拦截器
request.interceptors.response.use(
  (response) => {

    if (response.data.code === 401) {
      console.error(response.data.message);
      // 登录失效
      // if (!modalRef) {
      //   modalRef = Modal.error({
      //     title: '登录失效，请重新登录',
      //     content: <LoginForm onLogin={async (values) => {
      //       const response = await login(values);
      //       if (response.success) {
      //         modalRef?.destroy();
      //         location.reload();
      //       }
      //       return response;
      //     }} />,
      //     footer: false,
      //     closable: false
      //   })
      // }
      // location.href=`https://passport.ablula.tech/login?redirectUrl=${encodeURIComponent(location.href)}&appName=malette`
    }
    return response.data;
  },
  (err) => {
    // 对响应错误做点什么
    return Promise.reject(new BizError(err.message));
  },
);

export default request;
